import { ReportType } from '../../../domain/reports/ReportType'
import { adminHttpClient } from '../../commons/adminHttpClient'

export type EmployeesEndOfWeekNumbersReportFilter = {
  reportType: ReportType
  reportDate: string
}

export const getEmployessEndOfWeekAndEndOfMonthReport = (
  filter: EmployeesEndOfWeekNumbersReportFilter,
): Promise<any> => {
  return adminHttpClient.get('Csi/EmployeesEndOfWeekAndMonthReport', filter)
}
